import React, { useState } from 'react';
import { DurationInput } from '../ui/DurationInput';
export function CoolingOffTab() {
  const [duration, setDuration] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-557">
      <DurationInput label="Cooling Off Duration" value={duration} onChange={setDuration} helperText="Borrowers can cancel within this period without penalty" data-id="element-558" />
    </div>;
}